import { render } from "./GomokuGame.vue?vue&type=template&id=77f30016&scoped=true"
import script from "./GomokuGame.vue?vue&type=script&lang=js"
export * from "./GomokuGame.vue?vue&type=script&lang=js"

import "./GomokuGame.vue?vue&type=style&index=0&id=77f30016&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f30016"]])

export default __exports__